"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countMaxEntries = exports.useIsSerieHidden = exports.getNearestItems = exports.defaultPointTranslator = exports.ChartContext = void 0;
var react_1 = require("react");
exports.ChartContext = (0, react_1.createContext)(null);
function defaultPointTranslator(serie, item) {
    return item;
}
exports.defaultPointTranslator = defaultPointTranslator;
function getNearestItems(data, x, translator) {
    var nearItems = data.map(function (d) { return d.data.reduce(function (c, i, index) {
        i = translator(d, i);
        if (!c.item)
            return __assign(__assign({}, c), { item: i, index: index, xDistance: Math.abs(i.x - x) });
        var xDistance = Math.abs(i.x - x);
        if (xDistance < c.xDistance)
            return __assign(__assign({}, c), { item: i, xDistance: xDistance, index: index });
        return c;
    }, { serie: d }); });
    if (nearItems.length < 2)
        return nearItems;
    var nearest = nearItems.reduce(function (c, i) {
        if (!c)
            return i;
        if (i.xDistance < c.xDistance)
            return i;
        return c;
        i;
    }, null);
    var r = nearItems.filter(function (c) { return Math.abs(c.xDistance - nearest.xDistance) < 0.001; });
    return r;
}
exports.getNearestItems = getNearestItems;
function useIsSerieHidden() {
    var hidden = (0, react_1.useContext)(exports.ChartContext).hidden;
    return (0, react_1.useCallback)(function (serie) {
        if (!hidden)
            return false;
        return hidden.includes(serie);
    }, [hidden]);
}
exports.useIsSerieHidden = useIsSerieHidden;
function countMaxEntries(series) {
    return series.reduce(function (c, s) { return Math.max(c, s.data.length); }, 1);
}
exports.countMaxEntries = countMaxEntries;
//# sourceMappingURL=Chart.js.map